import { Component, OnInit, ViewChild } from '@angular/core';
import { AlertComponent } from '../objects/alert/alert/alert.component';
import { LoadingComponent } from '../objects/loading/loading.component';
import { NothingComponent } from '../objects/nothing/nothing.component';
import { Title } from '@angular/platform-browser';
import { AuthService } from 'src/app/Service/auth.service';
import { DataService } from 'src/app/Service/data.service';
import { AddZonaComponent } from './add-zona/add-zona.component';
import { Zona } from 'src/app/Models/zona/zona';
import { ALertOption } from 'src/app/Models/alert/alert-option';

@Component({
  selector: 'app-zonas',
  templateUrl: './zonas.component.html',
  styleUrls: ['./zonas.component.css']
})
export class ZonasComponent implements OnInit {
  @ViewChild(AddZonaComponent, null) newzona: AddZonaComponent;
  @ViewChild(LoadingComponent, null) public loading: LoadingComponent;
  @ViewChild(NothingComponent, null) public nothing: NothingComponent;
  @ViewChild(AlertComponent, null) public alert: AlertComponent;
  public busqueda: string = '';
  public usuario: any;
  public listazonas: any[] = [];
  public total: number = 0;
  public pgcliente: any;
  constructor(private title: Title, private data: DataService, private auth: AuthService) { }

  ngOnInit() {
    this.title.setTitle('Categorias de precios | Sistema de ventas');
    this.usuario = this.auth.getCurrentUser();
    this.GetZona()
  }


  GetZona() {
    this.loading.show('cargando datos');
    this.listazonas = [];

    this.data.GetSimple(this.data.api.zona).subscribe(r => {
      this.loading.hide();
      if (this.data.Exists(r)) {
        console.log(r);

        this.listazonas = r;
        this.total = this.listazonas.length;
      } else { this.listazonas = []; this.total = 0; }
    }, e => { console.log(e.error.text) });
  }

  busquedazona() {
    this.loading.show('cargando datos');
    this.listazonas = [];

    this.data.GetFromValue(this.data.api.zona, 'like', this.busqueda).subscribe(r => {
      this.loading.hide();
      if (this.data.Exists(r)) {
        console.log(r);

        this.listazonas = r;
        this.total = this.listazonas.length;
      } else { this.listazonas = []; this.total = 0; }
    }, e => { console.log(e.error.text) });
  }

  SearchZona() {
    if (this.busqueda != '') {
      this.busquedazona();
    } else {
      this.GetZona();
    }
  }

  AddZona() {
    this.newzona.zona = new Zona();
    this.newzona.isedit = false;
    this.newzona.show(() => {
      this.GetZona();
    });
  }

  EditZona(zona:any) {
    this.newzona.zona = zona; 
    this.newzona.isedit = true;
    this.newzona.show(() => {
      this.GetZona();
    });
  }

  DeleteZona(zona:any) {
    console.log("Info de zona",zona);
    let options = new ALertOption()
    options.showCancelButton = true;
    this.data.notify("Desea eliminar esta categoria?","Atencion",this.data.alertType.warning,options,() => {
      this.newzona.EliminarZona(zona.idzona).subscribe(
        (res)=>{
          this.data.notify("Categoria eliminada","Exito",this.data.alertType.success,options=new ALertOption(),()=>{this.GetZona()});
          
        },
        (error)=>{}
      )
    },()=>{console.log("eliminacion cancelada");
    })
  }

}
